import template from './productList.html';
import _ from 'lodash';
import './productList.scss';

class ProductListComponent {
    /*@ngInject*/
    constructor(dataContext, catalogService, $location, constants, $q) {
        this.dataContext = dataContext;
        this.catalogService = catalogService;
        this.$location = $location;
        this.constants = constants;
        this.$q = $q;
    }

    $onInit() {
        this.isLoading({ isLoading: true });
        this._setPanelType().then(() => {
                this._setProducts().finally(() => {
                    this.isLoading({ isLoading: false });
                });
            });
    }

    getProductDescription(product) {
        const descriptions = _.get(product, 'descriptions', undefined);
        if (!_.isNil(descriptions)) {
            const quickReview = _.find(product.descriptions, { reviewType: 'QuickReview' });
            return !_.isNil(_.get(quickReview, 'value', undefined)) ? quickReview.value.replace(/<(.|\n)*?>/g, '').replace(/&quot;/g, '"') : '';
        }
    }

    getCategoryName() {
        if (!_.isNil(this.categories) && this.categories.length > 0) {
            const parentCategory = _.find(this.categories, (category) => { return _.includes(this.$location.absUrl(), category.seoPath); });
            const subtitleProperty = _.find(parentCategory.properties, { name: 'subtitle' });
            return _.get(subtitleProperty, 'value', parentCategory.name);
        }
        return '';
    }

    _setPanelType() {
        return this.dataContext.panel.getVersion().then(response => {
            this.panelType = response.PanelType;
        });
    }
    
    _setProducts() {
        return this.$q.all([this.catalogService.getAllProducts(), this._setCategories()]).then((responses) => {
            //sort all products by sortOrder property
            const sortedProducts = _.sortBy(responses[0].data, (product) => {
                let sortOrder = _.find(product.properties, (property) => {
                    return property.name === 'sortOrder';
                });
                return !_.isNil(sortOrder) ? sortOrder.value : 99;
            });

            //get all products in parent and child categories
            this.products = _.filter(sortedProducts, (product) => {
                const hasProductInCategory = _.some(this.categories, (category) => {
                    return product.categoryId === category.id;
                });
                return hasProductInCategory && this._panelCheck(product);
            });
        });
    }

    _panelCheck(product) {
        let panel = _.find(this.constants.panels, { name: this.panelType });
        if (!_.isNil(panel)) {
            if (!_.isNil(product.properties)) {
                let property = _.find(product.properties, { name: panel.shopAllowProperty });
                if (!_.isNil(property)){
                    return property.value === 'True';
                }
            }
            return true;
        } else {
            // if they don't have a panel then no need to filter the products by panel
            return true;
        }
    }

    _setCategories() {
        return this.catalogService.searchCategories().then((categoriesResponse) => {
            //get current category
            const parentCategory = _(categoriesResponse.data.categories)
                .sortBy((category) => category.seoPath)
                .reverse()
                .find((category) => { return _.includes(this.$location.absUrl(), category.seoPath); });

            //set all parent and child categories
            const categoryId = _.get(parentCategory, 'id', undefined);
            this.categories = [];
            if (!_.isNil(categoryId)) {
                this.categories = _.filter(categoriesResponse.data.categories, (category) => {
                    return category.parentId === parentCategory.id;
                });
                this.categories.push(parentCategory);
            }
        });
    }
}

export default {
    template: template,
    bindings: {
        isLoading: '&'
    },
    controller: ProductListComponent
};